import { PageResponse, PageData, TMSAddressQuery, TMSAddressVo } from "@/types";
import { APIRequest } from "@/utils/api";

const AddressAPI = new APIRequest({
  baseURL: "/api/wms/v2/tms/addresses",
});

export async function queryAddresses(
  params: TMSAddressQuery,
): Promise<PageData<TMSAddressVo>> {
  return AddressAPI.get<PageResponse<TMSAddressVo>>({
    url: "",
    params,
  }).then((res) => res.data);
}
